import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useAppDispatch } from 'hooks/store';
import { setUserData } from 'store/authorization';

import Loader from 'components/Loader';
import { SESSION_STORAGE_URL } from '../../../constants/sessionStorage';

interface IData {
  AccessToken: string;
  RefreshToken: string;
  UserId: string;
  Username: string;
}
const DuoLogin: React.FC = () => {
  const [params] = useSearchParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const unparsed = params.get('data');
    if (unparsed) {
      const data = JSON.parse(unparsed) as IData;

      dispatch(
        setUserData({
          userId: data.UserId,
          accessToken: data.AccessToken,
          refreshToken: data.RefreshToken,
        }),
      );

      const url = sessionStorage.getItem(SESSION_STORAGE_URL);

      if (url) {
        navigate(url);
      }
    }
  }, []);

  return <Loader />;
};

export default DuoLogin;
